<template>
    <el-drawer
        :title="$t('pages.help.headlines.help')"
        :model-value="visible"
        direction="rtl"
        :with-header="false"
        :before-close="handleClose"
        @update:model-value="$emit('update:visible', $event)"
    >
        <div class="content">
            <span v-if="text" v-html="sanitizeHtml(text)" />
        </div>
    </el-drawer>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { sanitizeHtml } from '@/utils/sanitizeHtml'
import { useAuthStore } from '@/stores/auth'
import { useHelpStore } from '@/stores/help'

defineProps<{
    visible: boolean
}>()

const emit = defineEmits<{
    hide: []
    'update:visible': [value: boolean]
}>()

const authStore = useAuthStore()
const helpStore = useHelpStore()

const text = ref<string | null>(null)

function loadSettings() {
    if (authStore.user_id && !helpStore.help) {
        helpStore.getHelpText()
            .then((help) => {
                text.value = help.text
            })
            .catch(() => {})
    }
}

function handleClose(done: () => void) {
    emit('hide')
    done()
}

loadSettings()
</script>

<style scoped>
.content {
    padding: 20px;
}
</style>
